import { Component, inject } from '@angular/core';
import { BrightsideUiModule } from '@brightside/brightside-ui';
import { MicroUiMoleculeModule } from '@micro-ui/molecule';
import { TranslateModule } from '@ngx-translate/core';
import { SharedDesktopModule } from '@brightside-web/shared/desktop';
import { Router } from '@angular/router';
import { MessageBusInternalService, MessageBusOutgoingEventKey } from '@micro-core/message-bus';

@Component({
    selector: 'brightside-web-savi-splash',
    imports: [BrightsideUiModule, MicroUiMoleculeModule, TranslateModule, SharedDesktopModule],
    templateUrl: './savi-splash.component.html',
    styleUrl: './savi-splash.component.scss'
})
export class SaviSplashComponent {

  router = inject(Router);
  bgImage = './assets/student-loans-money-bg.png';


  goToSaviInfo() {
    this.router.navigate(['student-loans','savi']);
  }

  exitPage() {
    MessageBusInternalService.sendOutgoingHubEvent(
      {
        event: MessageBusOutgoingEventKey.EXIT_VIEW,
        bridgeSetting: {
          data: {},
        },
        fallbackSetting: {
          routeToUrl: '/home',
        },
      }
    );
  }
}
